import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { RefusedDocumentsView } from "@containers/refusedDocuments/RefusedDocumentsView";

const RefusedSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="refusedDocuments">
            <RefusedDocumentsView />
        </AuthenticatedLayout>
    );
}

export default RefusedSessionsPage;